import React from "react";
import { connect } from "react-redux";
import arcone from "assets/images/leftarc.svg";
import rightarc from "assets/images/rightarc.svg";
import {
  Box,
  Grid,
  Card,
  useTheme,
  Typography,
  CardContent,
  useMediaQuery,
} from "@mui/material";
import SubFooterView from "components/SubFooterView";
import FooterView from "./FooterView";
import mobileTopArc from "assets/images/mobile-top-curve.svg";

const SecondaryCenterTemplate = (props) => {
  const { children, pageTitle, organizationInfo } = props;
  const theme = useTheme();
  const matchesLg = useMediaQuery(theme.breakpoints.down("lg"));
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const isShowBackgroundAssets =
    organizationInfo?.organizationOptionJson?.showBackgroundAssetsFlag?.toUpperCase() ===
    "Y";

  return (
    <Grid container alignItems="center" justifyContent="center">
      <Grid
        item
        sm={8}
        xs={12}
        sx={{ minHeight: { xs: "450px", sm: "450px", md: "600px" } }}
      >
        {isShowBackgroundAssets && (
            <>
              <Box sx={{ display: matches ? "block" : "none" }}>
                <img
                  src={mobileTopArc}
                  alt="mabile-arc"
                  className="left-mobile-arc"
                  style={{ transform: "rotate(180deg)" }}
                />
              </Box>
              <Box sx={{ display: matches ? "none" : "block", zIndex: -1 }}>
                <img
                  src={arcone}
                  alt="top"
                  className="search-medication-top-curve"
                />
              </Box>
            </>
          )}
        {pageTitle && (
          <Box
            sx={{
              height: matchesSm ? "36px" : "44px",
              alignItems: "center",
              marginTop: matches ? "20px" : "40px",
              marginBottom: matches ? "0" : "40px",
            }}
          >
            <Typography
              variant="h1LatoBlack"
              sx={{
                fontSize: matches ? "24px" : undefined,
                paddingLeft: matches ? "24px" : undefined,
              }}
            >
              {pageTitle || ""}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            paddingLeft: matchesLg ? 0 : "3rem",
            paddingRight: matchesLg ? 0 : "3rem",
          }}
        >
          <Card
            sx={{
              minHeight: { xs: "450px", sm: "450px", md: "600px" },
              boxShadow: matchesLg ? "none" : "",
            }}
          >
            <CardContent
              sx={{
                textAlign: "center",
                padding: matchesLg ? "24px" : matchesSm ? "16px" : "40px 80px",
              }}
            >
              {children}
            </CardContent>
          </Card>
        </Box>
        {isShowBackgroundAssets && (
            <Box
              sx={{
                display: { xs: "none", sm: "none", md: "block" },
                zIndex: -1,
              }}
            >
              <img src={rightarc} alt="top" className="right-arc" />
            </Box>
          )}
      </Grid>
      <Grid item sm={12} sx={{ marginTop: "40px" }}>
        <SubFooterView />
        <FooterView />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
  };
};

export default connect(mapStateToProps)(SecondaryCenterTemplate);
